interface ISlideoutAmountDisplayProps {
  /** The formatted value to display prominently (e.g. "$45.99", "+$12.00"). */
  value: string;
}

const SlideoutAmountDisplay = ({ value }: ISlideoutAmountDisplayProps) => {
  return <div className="text-display-xl font-medium text-white">{value}</div>;
};

export default SlideoutAmountDisplay;
